import { render, staticRenderFns } from "./RsaPazientePriSchemaProgrammaQuadroEditComponent.vue?vue&type=template&id=6cf92a26"
import script from "./RsaPazientePriSchemaProgrammaQuadroEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePriSchemaProgrammaQuadroEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports